import { useLocation, useRoutes } from "react-router-dom";
import "./global.css";
import getRoutes from "./routes/Routes";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import FollowMouse from "./components/followmouse/FollowMouse";
import { useMediaQuery } from "react-responsive";

function App() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const location = useLocation();
  const routes = getRoutes();
  const element = useRoutes(routes, location);

  const { theme } = useSelector((state) => state.theme); // "light" veya "dark"

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <>
      {isMobile === false && <FollowMouse/>}
      {element}
    </>
  );
}

export default App;
